import { useLocation, Link } from "react-router-dom";

const NotFound = () => {
  const location = useLocation();

  // Log 404 errors in development only
  if (process.env.NODE_ENV === 'development') {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-4">Oops! Page not found</p>
        <Link to="/" className="text-blue-500 hover:text-blue-700 underline">
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
